import { Clock, CheckCircle, Package, AlertTriangle } from "lucide-react";
import type { ReceptorActionStatus } from "../types";
import { RECEPTOR_STATUS_LABELS, RECEPTOR_STATUS_COLORS } from "../types";

interface ReceptorStatusBadgeProps {
  status: ReceptorActionStatus;
  compact?: boolean;
}

const RECEPTOR_STATUS_ICONS: Record<ReceptorActionStatus, typeof Clock> = {
  pending: Clock,
  accepted: CheckCircle,
  goods_received: Package,
  claimed_content: AlertTriangle,
  claimed_partial: AlertTriangle,
  claimed_total: AlertTriangle,
  auto_accepted: CheckCircle,
};

/**
 * Badge showing receptor (commercial) acceptance status.
 *
 * This is separate from the SII tax authority status.
 * Receptor status tracks whether the recipient has accepted/rejected
 * the document for commercial purposes.
 */
export function ReceptorStatusBadge({
  status,
  compact = false,
}: ReceptorStatusBadgeProps) {
  const Icon = RECEPTOR_STATUS_ICONS[status];
  const label = RECEPTOR_STATUS_LABELS[status];
  const colorClass = RECEPTOR_STATUS_COLORS[status];

  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium ${colorClass}`}
        title={`Receptor: ${label}`}
      >
        <Icon className="h-2.5 w-2.5" />
        {label}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
